@if (freight().nextStopStatus === 'UNSTARTED') {
  <ion-button
    fill="solid"
    [color]="buttonColor()"
    [disabled]="isOffline()"
    expand="block"
    (click)="saveStartStop()"
    libClickStopPropagation
  >
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/play_circle_24dp.svg"
    ></ion-icon>
    {{ 'tasks.arrival' | translate }}
  </ion-button>
} @else if (freight().nextStopStatus === 'STARTED') {
  <ion-button
    fill="solid"
    [color]="buttonColor()"
    [disabled]="isOffline()"
    expand="block"
    (click)="saveEndStop()"
    libClickStopPropagation
  >
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/stop_circle_24dp.svg"
    ></ion-icon>
    {{ 'tasks.departure' | translate }}
  </ion-button>
}
